
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.277.766a.976.976 0 011.34 0L6 4.972 10.383.766a.976.976 0 011.34 0c.37.355.37.93 0 1.286L6.67 6.9a.976.976 0 01-1.34 0L.277 2.052a.883.883 0 010-1.286z","fill":"#000"}})])
          )
        }
      }
    